var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.16667C3.77834 1.16667 1.16667 3.77834 1.16667 7C1.16667 10.2217 3.77834 12.8333 7 12.8333C10.2217 12.8333 12.8333 10.2217 12.8333 7C12.8333 3.77834 10.2217 1.16667 7 1.16667ZM0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7ZM7 3.5C7.32217 3.5 7.58333 3.76117 7.58333 4.08333V7C7.58333 7.32217 7.32217 7.58333 7 7.58333C6.67783 7.58333 6.41667 7.32217 6.41667 7V4.08333C6.41667 3.76117 6.67783 3.5 7 3.5ZM7 8.75C7.32217 8.75 7.58333 9.01117 7.58333 9.33333V9.625C7.58333 9.94717 7.32217 10.2083 7 10.2083C6.67783 10.2083 6.41667 9.94717 6.41667 9.625V9.33333C6.41667 9.01117 6.67783 8.75 7 8.75Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alertInfo.254ec92e7adb68f38f0dd36aece6348c.svg";
export { ForwardRef as ReactComponent };